/** The brand picker's choices (BrandPicker.tsx), kept free of React so they can be tested. */
import type { BrandRow } from '../api'

export const BRAND_HELP = "Pick one so the piece shows on that brand's page. Leave it blank for pieces that aren't about one brand."
export const MAX_SHOWN = 8
export const brandsKey = (pub: string) => ['editorial-brands', pub] as const

/** A brand's address as the server makes it (section_brands.brand_slug). */
export function brandSlug(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80).replace(/-+$/g, '')
}

export function optionLabel(b: BrandRow): string {
  return `${b.name} · ${b.live_count} ${b.live_count === 1 ? 'piece' : 'pieces'}`
}

export const addLabel = (text: string) => `+ Add “${text.trim()}” as a new brand`

export const closingLine = (name: string) => `Added automatically when published: See more posts about ${name} →`

export type BrandOption = { kind: 'brand'; brand: BrandRow } | { kind: 'add'; name: string }

/** What the list offers for the text typed: matching brands (names that start with it first),
 *  then "Add … as a new brand" when no brand has that address yet. */
export function brandOptions(brands: BrandRow[], text: string): BrandOption[] {
  const q = text.trim().toLowerCase()
  const hits = q
    ? brands.filter((b) => b.name.toLowerCase().includes(q))
      .sort((a, b) => Number(!a.name.toLowerCase().startsWith(q)) - Number(!b.name.toLowerCase().startsWith(q)))
    : brands
  const out: BrandOption[] = hits.slice(0, MAX_SHOWN).map((brand) => ({ kind: 'brand', brand }))
  const slug = brandSlug(text)
  if (slug && !brands.some((b) => b.slug === slug)) out.push({ kind: 'add', name: text.trim() })
  return out
}
